import { CATEGORIES } from "../lib/categories.js";

// Horizontale categorie-filterrij (Airbnb-stijl).
export function CategoryBar({ active, onChange }) {
  return (
    <div className="cat-bar" role="tablist" aria-label="Categorie-filters">
      {CATEGORIES.map(cat => (
        <button
          key={cat.id}
          role="tab"
          aria-selected={active === cat.id}
          className={`cat-item${active === cat.id ? " cat-active" : ""}`}
          onClick={() => onChange(cat.id)}
        >
          <span className="cat-icon">{cat.icon}</span>
          <span className="cat-label">{cat.label}</span>
        </button>
      ))}
    </div>
  );
}
